var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('verification-process',{attrs:{"translation-text":_vm.translationText,"mobile-dispatch":"person/verifyMobileNumber","email-dispatch":"person/verifyEmail","otp-dispatch":"person/verifyOtpForLogin","register":""}})}
var staticRenderFns = []

export { render, staticRenderFns }